import React from "react";
import { IconBasket1 } from "../../assets/icons";
function AddToBasketRoundedButton({ onClick }) {
  const handleShowModal = () => {
    onClick(true);
  };
  return (
    <button className="bg-primary btn-rounded">
      <IconBasket1 fillColor="#fff" onClick={handleShowModal} />
    </button>
  );
}
export default AddToBasketRoundedButton;
